module.exports = __webpack_public_path__ + "static/img/status_indication03.268c41d.gif";


//////////////////
// WEBPACK FOOTER
// ./src/images/air_2020/status_indication03.gif
// module id = q93K
// module chunks = 1